import api from "./Api";

class UsuarioService {
  GetUsuario(payload) {
    return api.get("/v1/usuario/" + payload).then((response) => {
      return response.data;
    });
  }

  PostUsuario(payload) {
    return api.post("/v1/usuario/", payload).then((response) => {
      return response.data;
    });
  }

  PutUsuario(payload) {
    return api.put("/v1/usuario/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteUsuario(payload) {
    return api.delete("/v1/usuario/" + payload).then((response) => {
      return response.data;
    });
  }

  GetUsuarioOData(payload) {
    return api.get("/OData/Usuario" + payload).then((response) => {
      return response.data;
    });
  }

  PutRedefinirSenhaUsuario(payload) {
    return api.put("/v1/redefinirSenhaUsuario/", payload).then((response) => {
      return response.data;
    });
  }

  PutAlterarSenhaUsuario(payload) {
    return api.put("/v1/alterarSenhaUsuario/", payload).then((response) => {
      return response.data;
    });
  }

  PutAlterarEmailUsuario(payload) {
    return api.put("/v1/alterarEmailUsuario/", payload).then((response) => {
      return response.data;
    });
  }

  GetByUsuarioExists(payload) {
    return api.post("/v1/getByUsuarioExists/", payload).then((response) => {
      return response.data;
    });
  }
}

export default new UsuarioService();
